import { useQuery } from "@tanstack/react-query";
import {
  getCapacity,
  getNodeMetrics,
  getAlerts,
} from "@/api/endpoints/monitoring";

export function useCapacity() {
  return useQuery({
    queryKey: ["capacity"],
    queryFn: getCapacity,
    refetchInterval: 60_000, // Refresh every minute
  });
}

export function useNodeMetrics() {
  return useQuery({
    queryKey: ["node-metrics"],
    queryFn: getNodeMetrics,
    refetchInterval: 30_000, // Refresh every 30 seconds
  });
}

export function useAlerts() {
  return useQuery({
    queryKey: ["alerts"],
    queryFn: getAlerts,
    refetchInterval: 30_000,
  });
}
